import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/invite/$inviteId')({
  loader: ({ context: { auth } }) => {
    if (auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  }
});
